<template>
  <aside class="o-edition-section-navigation">
    <MoleculeEditionSectionNavigationMenu/>
  </aside>
</template>

<script>
export default {
  name: 'OrganismEditionSectionNavigation',

  components: {
    MoleculeEditionSectionNavigationMenu: () => import('@/components/molecules/MoleculeEditionSectionNavigationMenu')
  }
}
</script>
